import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
import * as React from 'react';
import EcommEmptyState from 'automation-ui-canvas/components/embed/EcommEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
export const EMPTY_STATES = {
  ecomm: EcommEmptyState
};
const EmptyState = props => {
  const {
      use
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const EmptyStateComponent = EMPTY_STATES[use];
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "automation-empty-state-container",
    children: /*#__PURE__*/_jsx(EmptyStateComponent, Object.assign({}, rest))
  });
};
export default EmptyState;